import { store, persistor } from "./redux/store";
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
/* Slick carousel CSS imported only once globally */
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
/* Global + fonts */
import './Styles/global.css';
import './Styles/fonts.css';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import './Styles/toastStyles.css';


ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer />
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </HelmetProvider>
  ,
  document.getElementById('root')
);